export const quizDominio = process.env.REACT_APP_QUIZ_DOMINIO;
